<palantir-modal
  class="filter-dialog"
  role="dialog"
  [attr.aria-labelledby]="'filter-modal-title-' + instance.id"
  [attr.aria-modal]="true"
>
  <palantir-toolbar palantir-modal-header>
    <palantir-toolbar-main>
      <palantir-text
        class="filter-dialog__title"
        truncate="true"
        type="title"
        size="xl"
        palantir-toolbar-main-title
        [attr.id]="'filter-modal-title-' + instance.id"
        >{{ instance.metadata.title }}</palantir-text
      >
    </palantir-toolbar-main>

    <palantir-toolbar-suffix>
      @if (instance.isFiltering()) {
        <palantir-button
          theme="outline"
          size="xs"
          layout="prefix"
          variant="neutral"
          (click)="clearFilters()"
          [icon]="instance.metadata.clearFilterButton.icon ?? 'filter-off-filled'"
          [attr.aria-label]="instance.metadata.clearFilterButton.label + ' (Ctrl+K)'"
        >
          {{ instance.metadata.clearFilterButton.label }}
        </palantir-button>
      }

      <palantir-button
        theme="outline"
        size="xs"
        layout="icon"
        variant="neutral"
        [palantirTooltip]="instance.metadata.closeFilterButton.tooltip"
        icon="close-outline"
        (click)="close()"
        [attr.aria-label]="instance.metadata.closeFilterButton.tooltip + ' (Esc)'"
      />
    </palantir-toolbar-suffix>
  </palantir-toolbar>

  <div palantir-modal-content class="palantir-scrollbar filter-dialog__container">
    @if (instance.metadata.banner) {
      <div class="filter-dialog__banner">
        <palantir-icon [name]="instance.metadata.banner.icon" class="filter-dialog__banner__icon" />
        <palantir-text size="base" type="description">{{
          instance.metadata.banner.text
        }}</palantir-text>
      </div>
    }
    @if (instance.metadata.search.enabled !== false) {
      <palantir-input prefix="search-outline">
        <input
          type="text"
          [placeholder]="instance.metadata.search.placeholder"
          [formControl]="searchControl"
          [attr.aria-label]="instance.metadata.search.placeholder"
          role="searchbox"
        />
      </palantir-input>
    }
    @for (filterDefinition of this.filteredOptions(); track filterDefinition.key) {
      @switch (filterDefinition.value.type) {
        @case ('TEXT') {
          <palantir-filter-modal-text-input-component
            [definition]="filterDefinition.value"
            [control]="getFormControl(filterDefinition.key, filterDefinition.value.type)"
            [modalInstance]="instance"
          />
        }
        @case ('NUMBER') {
          <palantir-filter-modal-text-input-component
            [definition]="filterDefinition.value"
            inputType="number"
            [control]="getFormControl(filterDefinition.key, filterDefinition.value.type)"
            [modalInstance]="instance"
          />
        }
        @case ('DATE') {
          <palantir-filter-modal-date-input-component
            [definition]="filterDefinition.value"
            [control]="getFormControl(filterDefinition.key, filterDefinition.value.type)"
            [modalInstance]="instance"
          />
        }
        @case ('DATE_RANGE') {
          <palantir-filter-modal-date-range-input-component
            [definition]="filterDefinition.value"
            [controlGroup]="getFormControl(filterDefinition.key, filterDefinition.value.type)"
            [modalInstance]="instance"
          />
        }
        @case ('SELECT') {
          <palantir-filter-modal-select-input-component
            [definition]="filterDefinition.value"
            [control]="getFormControl(filterDefinition.key, filterDefinition.value.type)"
            [modalInstance]="instance"
          />
        }
        @case ('MULTI_SELECT') {
          <palantir-filter-modal-multi-select-input-component
            [definition]="filterDefinition.value"
            [control]="getFormControl(filterDefinition.key, filterDefinition.value.type)"
            [modalInstance]="instance"
          />
        }
        @case ('MULTI_SEARCH') {
          <palantir-filter-modal-search-input-component
            [definition]="filterDefinition.value"
            [control]="getFormControl(filterDefinition.key, filterDefinition.value.type)"
            [modalInstance]="instance"
          />
        }
        @case ('SEARCH') {
          <palantir-filter-modal-search-input-component
            [definition]="filterDefinition.value"
            [control]="getFormControl(filterDefinition.key, filterDefinition.value.type)"
            [modalInstance]="instance"
          />
        }
        @case ('CUSTOM') {
          <ng-container
            *ngComponentOutlet="
              filterDefinition.value.component;
              inputs: {
                definition: filterDefinition.value,
                control: getFormControl(filterDefinition.key, filterDefinition.value.type),
                modalInstance: instance,
              }
            "
          />
        }
        @default {
          <div>Unknown filter type: {{ filterDefinition.value.type }}</div>
        }
      }
    } @empty {
      <div class="filter-dialog__empty">
        <palantir-text size="lg" type="description">{{
          instance.metadata.search.emptyMessage ?? 'No filters defined'
        }}</palantir-text>
      </div>
    }
  </div>
</palantir-modal>
